import { RootState } from 'store/index';

export const selectUser = ({ auth }: RootState) => {
  const { user } = auth;
  return user;
};

export const selectUserName = ({ auth }: RootState) => {
  const { user } = auth;

  if (!user) return '';

  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }

  if (user.firstName) {
    return user.firstName;
  }

  if (user.email) {
    return user.email;
  }

  return user.id;
};

export const selectUserFirstName = ({ auth }: RootState) => {
  const { user } = auth;
  return user?.firstName ?? '';
};

export const selectUserLastName = ({ auth }: RootState) => {
  const { user } = auth;
  return user?.lastName ?? '';
};

export const selectUserEmail = ({ auth }: RootState) => {
  const { user } = auth;
  return user?.email ?? '';
};

export const selectCampaignLimits = ({ auth }: RootState) => {
  return auth.campaignLimits;
};

export const selectCompendiumCampaignId = ({ auth }: RootState) => {
  return auth.user?.compendiumCampaignId ?? null;
};
